// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3DIfs","counter":"_3IeI0","small":"_2ve_x"};